export default __webpack_public_path__ + "static/mastermatchmaker_screen_1-316310486e59bc4bfbff0bc5b6978148.svg";